import { OrderForm } from 'src/sdk/checkout/entity/orderForm'
import type { OrderFormAPI } from 'src/sdk/checkout/data/types'

import { axiosClient } from './axiosInstance'

interface BaseAddressParams {
  orderFormId: string
  syncOrderFormFn: (orderForm: OrderForm) => void
}

interface CreateAddressParams extends BaseAddressParams {
  address: ShippingAddressInput
}

interface UpdateAddressParams extends BaseAddressParams {
  addressId: string
  address: ShippingAddress
}

interface SelectOrDeleteParams extends BaseAddressParams {
  addressId: string
}

interface GetDefaultAddressParams {
  orderFormId: string
}

interface SetDefaultParams extends GetDefaultAddressParams {
  addressId: string
}

export const addressService = {
  createAddress: async ({
    orderFormId,
    address,
    syncOrderFormFn,
  }: CreateAddressParams): Promise<OrderFormAPI> => {
    const { data } = await axiosClient.post<OrderFormAPI>(
      '/api/account/address/createAddress',
      {
        orderFormId,
        address,
      }
    )

    syncOrderFormFn(new OrderForm(data))

    return data
  },
  updateAddress: async ({
    orderFormId,
    addressId,
    address,
    syncOrderFormFn,
  }: UpdateAddressParams): Promise<OrderFormAPI> => {
    const { data } = await axiosClient.put<OrderFormAPI>(
      '/api/account/address/updateAddress',
      {
        orderFormId,
        addressId,
        address,
      }
    )

    syncOrderFormFn(new OrderForm(data))

    return data
  },

  deleteAddress: async ({
    orderFormId,
    addressId,
    syncOrderFormFn,
  }: SelectOrDeleteParams): Promise<OrderFormAPI> => {
    const { data } = await axiosClient.post<OrderFormAPI>(
      '/api/account/address/deleteAddress',
      {
        orderFormId,
        addressId,
      }
    )

    syncOrderFormFn(new OrderForm(data))

    return data
  },

  selectAddress: async ({
    orderFormId,
    addressId,
    syncOrderFormFn,
  }: SelectOrDeleteParams): Promise<OrderFormAPI> => {
    const { data } = await axiosClient.put<OrderFormAPI>(
      '/api/account/address/selectAddress',
      {
        orderFormId,
        addressId,
      }
    )

    syncOrderFormFn(new OrderForm(data))

    return data
  },

  getDefaultAddress: async ({
    orderFormId,
  }: GetDefaultAddressParams): Promise<DefaultAddressResponse> => {
    const { data } = await axiosClient.get<DefaultAddressResponse>(
      `/api/account/address/defaultAddress/${orderFormId}`
    )

    return data
  },

  setDefaultAddress: async ({
    addressId,
    orderFormId,
  }: SetDefaultParams): Promise<void> => {
    await axiosClient.put(
      `/api/account/address/defaultAddress/${orderFormId}`,
      { addressId }
    )
  },
}
